export default "__VITE_ASSET__CCPlV1gF__"